/* src/app/components/auth/login/login.component.scss */
* {
  box-sizing: border-box;
}
:host {
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  animation: gradientAnimation 12s ease infinite;
  background:
    radial-gradient(
      circle,
      #00a4a4,
      rgba(46, 49, 49, 0.6941176471));
  background-size: 200% 200%;
}
.mbsc-ios .mbsc-form-grid .mbsc-textfield-wrapper {
  margin: 0.75em 1em;
}
c-card {
  background-color: rgba(255, 255, 255, 0.671);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.3);
}
@media (min-width: 900px) {
  c-card {
    min-width: 800px;
  }
}
c-card c-card-header {
  display: flex;
  justify-content: center;
  border-bottom: none;
  background-color: rgba(255, 255, 255, 0);
}
c-card c-card-header .logo {
  height: 100px;
  width: auto;
}
@media (max-width: 500px) {
  c-card c-card-header .logo {
    height: 60px;
  }
}
c-card .form-group {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
c-card .form-group mbsc-input {
  width: 80%;
}
@media (max-width: 500px) {
  c-card .form-group mbsc-input {
    width: 100%;
  }
}
c-card .form-group button {
  font-size: 16px;
  outline: none;
  border-radius: 5px;
  padding: 8px 15px;
  width: 70%;
  margin-top: 20px;
  border: 1px solid #00A4A4;
  color: #00A4A4;
}
c-card .form-group button:hover {
  background-color: #00A4A4;
  color: white;
}
c-card .form-group .valid-btn {
  background-color: #00a4a4;
  color: white !important;
  border: none;
  padding: 8px 15px;
  position: relative;
  overflow: hidden;
  text-align: center;
  transition:
    color 0.3s ease,
    transform 0.3s ease,
    box-shadow 0.3s ease;
}
c-card .form-group .valid-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 70%;
  height: 100%;
  background:
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.1) 25%,
      rgba(255, 255, 255, 0.3) 50%,
      rgba(255, 255, 255, 0.1) 75%);
  animation: shine 4s ease-in-out infinite;
}
c-card .form-group .valid-btn:hover {
  color: #00a4a4;
  transform: scale(1.05);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}
@keyframes shine {
  0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: -100%;
  }
}
@keyframes slideIn {
  0% {
    transform: translateY(-20%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes gradientAnimation {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
@keyframes shadowAnimation {
  0% {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.3);
  }
  50% {
    box-shadow: 10px 15px 20px 10px rgba(0, 0, 0, 0.5);
  }
  100% {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.5);
  }
}
/*# sourceMappingURL=login.component.css.map */
